import { Component, OnInit } from '@angular/core';
import {AngularFireDatabase, AngularFireList, AngularFireObject} from '@angular/fire/database';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import {EvaluationMeasures} from '../shared/models/evaluation-measures.model';
import {ApiService} from '../api.service';
import {PretrainInfo} from '../shared/models/pretrain-info.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  logText: any[];
  pretrainCount: number;
  predictCount: number;
  constructor(private db: AngularFireDatabase, private apiService: ApiService) {
    // Getting pre-train info
    this.pretrainInfoRef = db.object('asips-3efdd-default-rtdb/PretrainInfo');
    this.pretrainInfoRef.snapshotChanges().subscribe(action => {
      this.pretrainInfo = action.payload.val();
    });
    // Getting current measures
    this.currentMeasuresRef = db.object('asips-3efdd-default-rtdb/CurrentEvaluationMeasures');
    this.currentMeasuresRef.snapshotChanges().subscribe(action => {
      this.evaluationMeasures = action.payload.val();
    });
    // Getting current mean measures
    this.currentMeanMeasuresRef = db.object('asips-3efdd-default-rtdb/CurrentMeanEvaluationMeasures');
    this.currentMeanMeasuresRef.snapshotChanges().subscribe(action => {
      this.evaluationMeanMeasures = action.payload.val();
    });
    // logs
    this.logText = [];
    // Getting kappa arrays for charts and init charts
    this.kappaArrayRef = db.list('asips-3efdd-default-rtdb/MeanPerformances/kappa');
    this.meanKappaArrayRef = db.list('asips-3efdd-default-rtdb/MeanPerformances/meanKappa');
    let valuesKappa = [];
    let valuesMKappa = [];
    let labels = [];
    let chartValues = [
      { data: valuesKappa, label: 'Kappa' },

      { data: valuesMKappa, label: 'Mean of the Kappa' }
    ];
    this.chartDatasets = chartValues;
    this.kappaArrayRef.snapshotChanges(['child_added'])
      .subscribe(actions => {
        valuesKappa = [];
        labels = [];
        actions.forEach(action => {
          console.log(action.type);
          console.log(action.key);
          console.log(action.payload.val());
          valuesKappa[valuesKappa.length] = action.payload.val();
          labels[labels.length] = action.key;
          // this.kappaArray.concat(action.payload.val());

          chartValues = [
            // @ts-ignore
            { data: valuesKappa, label: 'Kappa' },
            // @ts-ignore

            { data: valuesMKappa, label: 'Mean of the Kappa' }
          ];

          this.chartDatasets = chartValues;
          this.chartLabels =  labels;
        });
      });
    this.meanKappaArrayRef.snapshotChanges(['child_added'])
      .subscribe(actions => {
        valuesMKappa = [];
        labels = [];
        actions.forEach(action => {
          console.log(action.type);
          console.log(action.key);
          console.log(action.payload.val());
          valuesMKappa[valuesMKappa.length] = action.payload.val();

          chartValues = [
            // @ts-ignore
            { data: valuesKappa, label: 'Kappa' },
            // @ts-ignore

            { data: valuesMKappa, label: 'Mean of the Kappa' }
          ];

          this.chartDatasets = chartValues;
        });
      });
  }
  // pre-train info
  pretrainInfoRef: AngularFireObject<PretrainInfo>;
  pretrainInfo: PretrainInfo;
  // current evaluation measure
  currentMeasuresRef: AngularFireObject<EvaluationMeasures>;
  evaluationMeasures: EvaluationMeasures;
  // current mean evaluation measure
  currentMeanMeasuresRef: AngularFireObject<EvaluationMeasures>;
  evaluationMeanMeasures: EvaluationMeasures;
  // charts
  kappaArrayRef: AngularFireList<any>;
  meanKappaArrayRef: AngularFireList<any>;
  public chartType = 'line';
  public chartDatasets: Array<any> = [];
  //   Array<any> =
  public chartLabels = [];

  public chartColors: Array<any> = [
    {
      backgroundColor: 'rgba(105, 0, 132, .2)',
      borderColor: 'rgba(200, 99, 132, .7)',
      borderWidth: 2,
    },
    {
      backgroundColor: 'rgba(0, 137, 132, .2)',
      borderColor: 'rgba(0, 10, 130, .7)',
      borderWidth: 2,
    }
  ];

  public chartOptions: any = {
    responsive: true
  };
  x: any;

  pretrain() {
    this.apiService.pretrain(this.pretrainCount)
      .subscribe(data => {
        console.log('data.message');
        console.log(data.message);
        this.logText[this.logText.length] = data.message;
        this.x = data.message;
        // this.refreshPeople();
      });
  }
  makePrediction() {
    if(this.predictCount<22){
      alert("Invalid input! " +
        "\nEnter atleast 25 samples.");
    }
    else{
      this.apiService.makePrediction(this.predictCount)
        .subscribe(data => {
            console.log(data.message);
            this.logText[this.logText.length] = data.message;
          },
          error => {
            this.logText[this.logText.length]  = error.message;
            console.error('There was an error!', error);
          });}
  }

  public chartClicked(e: any): void { }
  public chartHovered(e: any): void { }
  ngOnInit(): void {

  }

}
